import {openApInterfaceSection} from '../apSections/adapter';

/**
 * Canvas Access Point dashboard > Access Point Interface.
 *
 * An accordion inside one Access Point, so the context is `ap` and the
 * workflow asks which Access Point when the request did not name one. The
 * page reports when the accordion is actually showing, which is what makes
 * this verified rather than merely registered.
 */
const apInterfacePlugin = {
	id: 'ap_interface',
	version: 1,
	commandVersion: 1,
	resource: 'ap_interface',
	operations: ['view'],
	dependencies: {
		plugins: ['canvas.navigation'],
		destinations: ['ap.dashboard'],
	},
	sections: {
		'ap.interface': openApInterfaceSection,
	},
};

export default apInterfacePlugin;
